module.exports = __webpack_public_path__ + "static/img/head_invite.ddae19b0.jpg";